<div class="wrapper wrapper-dark">
  <div class="title-section mb-5">{{"INFORMATIVA AL TRATTAMENTO DEI DATI PERSONALI"|translate}}</div>

  <div class="privacy-content">
    [Ed. 01 Rev. 00 del 26/06/2018]

    Ai sensi del Regolamento Europeo 2016/679 desideriamo informarVi che:<br>
    I dati personali da Voi forniti o acquisiti nell'ambito dei rapporti contrattuali con Voi intercorrenti,
      vengono utilizzati allo scopo di:<br><br>
    I dati relativi ai clienti, intesi come dati anagrafici, quali ragione sociale, indirizzo, partita iva, sede
      legale, IBAN di appoggio per le RI.BA ecc. vengono utilizzati per la fatturazione. <br>Altri dati, come
      indirizzi email e numeri di telefono, vengono utilizzati per contattare il cliente.<br> Altri dati relativi al
      cliente non vengono trattati.<br><br>
    In occasione di tali trattamenti è possibile venire a conoscenza di dati che il Regolamento Europeo
      2016/679 definisce “sensibili”.
    Il trattamento dei dati conferiti avviene nel rispetto delle norme vigenti, a mezzo di strumenti
      CARTACEI ED INFORMATICI idonei a tutelare la Vostra sicurezza e riservatezza, nel rispetto delle
      misure minime previste dal Regolamento Europeo 2016/679.<br><br>
    Tale trattamento consiste nella raccolta, registrazione, organizzazione, conservazione,
      consultazione, elaborazione, duplicazione, estrazione, selezione, raffronto, utilizzo, cancellazione e
      distruzione dei dati stessi;<br>
    Il conferimento dei dati personali richiesti è obbligatorio, una loro mancata o parziale
      comunicazione impedirebbe di instaurare rapporti con la scrivente in quanto risulterebbe
      impossibile adempiere al contratto;<br>
    I dati forniti o acquisiti nel corso del rapporto contrattuale potranno essere comunicati a soggetti
      esterni che svolgono specifici incarichi per conto dell'azienda.<br>
    E' prevista la possibilità di diffondere i vostri dati per adempiere ai requisiti legislativi e
      contrattuali.<br><br>
    <!--TABELLA DATI-->
    <table class="ref_privacy">
      <tr style="border-bottom: 1px solid #999;">
        <td><b>SPS s.r.l. - CORSO UNIONE SOVIETICA 612/21, 10135 TORINO<br><br>
          GIUSEPPE PANETTA</b></td>
        <td><br><br><i>&nbsp;&nbsp;Titolare del trattamento</i></td>
      </tr>
      <tr style="border-bottom: 1px solid #999;">
        <td><b>Giuseppe Panetta</b></td>
        <td>&nbsp;&nbsp;<i>Responsabili del Trattamento dei Dati</i></td>
      </tr>
    </table>
    <br><br>
    I dati conferiti saranno trattati da personale incaricato nominato direttamente dal Responsabile
      del Trattamento.
    <ul>
      <li>I dati personali non sono trasferiti all'estero;</li>
      <li>I dati personali sono conservati per una durata massima di cinque anni e/o fina alla conclusione del rapporto
        contrattuale.</li>
    </ul>
    <br>
    <B>DIRITTI DELL'INTERESSATO</B><br>
    Ai sensi dell'art. 7 Codice Privacy, in qualsiasi momento l'interessato ha diritto di ottenere la
      conferma dell'esistenza o meno dei dati che lo riguardano e di conoscerne il contenuto e l'origine,
      di verificarne l'esattezza o chiederne l'integrazione o l'aggiornamento, oppure la rettificazione. <br>Ha
      altresì il diritto di chiedere la cancellazione, la trasformazione in forma anonima o il blocco dei dati
      trattati in violazione di legge, nonché di opporsi per motivi legittimi al trattamento dei dati che la
      riguardano. Le relative richieste vanno rivolte al titolare del trattamento.<br>
      Nel caso in cui i dati siano trattati in base ai <b>legittimi interessi</b> sono comunque garantiti i diritti
      degli interessati al trattamento (tranne il diritto alla portabilità che non è previsto dalle norme), in
      particolare il diritto di opposizione al trattamento che può essere esercitato inviando una richiesta
      al titolare del trattamento.
      <br><br>
    <b>DIRITTI DELL'UTENTE</b><br>
    Ai sensi del Regolamento europeo 679/2016 (GDPR) e della normativa nazionale, l'Utente può,
      secondo le modalità e nei limiti previsti dalla vigente normativa, esercitare i seguenti diritti:<br>
    <ul>
      <li>Richiedere la conferma dell'esistenza di dati personali che lo riguardano (diritto di accesso);</li>
      <li>Conoscerne l'origine;</li>
      <li>Riceverne comunicazione intelligibile;</li>
      <li>Avere informazioni circa la logica, le modalità e le finalità del trattamento;</li>
      <li>Richiederne l'aggiornamento, la rettifica, l'integrazione, la cancellazione, la trasformazione in forma
        anonima,
        il blocco dei dati trattati in violazione di legge, ivi compresi quelli non più necessari al perseguimento degli
        scopi per i quali sono stati raccolti;</li>
      <li>Nei casi di trattamento basato su consenso, ricevere al solo costo dell'eventuale supporto, i suoi dati
        forniti
        al titolare, in forma strutturata e leggibile da un elaboratore di dati e in un formato comunemente usato da un
        dispositivo elettronico;</li>
      <li>Il diritto di presentare un reclamo all'Autorità di controllo (Garante Privacy)</li>
      <li>Nonché, più in generale, esercitare tutti i diritti che gli sono riconosciuti dalle vigenti disposizioni di
        legge.</li>
    </ul>


    Le richieste vanno rivolte al Titolare del trattamento.<br><br>
    <b>TITOLARE DEL TRATTAMENTO</b><br>
    Il titolare del trattamento della <b>SPS s.r.l.</b> è il Sig. <b>GIUSEPPE PANETTA</b>, 
    raggiungibile ed interpellabile ai seguenti recapiti:<br>
    Mail: <a href="mailto:giuseppe.panetta@spsautomazione.it">giuseppe.panetta@spsautomazione.it</a><br>
    <!-- Tel.: <b>011-501188</b><br> -->
    Tel.: <b>011 2495021</b><br>
    Indirizzo (sede operativa) <b>CORSO UNIONE SOVIETICA 612/21, 10135 TORINO</b>
  </div>
</div>